"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _vue = _interopRequireDefault(require("vue"));

var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));

var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));

var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));

var _state = _interopRequireDefault(require("./state"));

var nextId = 0;

var Message = /*#__PURE__*/function () {
  function Message(message, user) {
    (0, _classCallCheck2.default)(this, Message);
    this.id = extractMessageId(message) || nextId++; // Two different times;
    //   time = time in the users local time
    //   server_time = time the server gave us

    this.time = message.time || (0, _now.default)();
    this.server_time = message.server_time || this.time;
    this.nick = message.nick;
    this.message = message.message;
    this.tags = message.tags;
    this.type = message.type || 'message';
    this.type_extra = message.type_extra;
    this.ignore = false;
    this.mentioned_urls = []; // If embed.payload is truthy, it will be embedded within the message

    this.embed = {
      type: 'url',
      payload: null
    };
    this.html = '';
    this.hasRendered = false; // template should be null or a Vue component to render this message

    this.template = message.template || null; // bodyTemplate should be null or a Vue component to render in the body of the message

    this.bodyTemplate = message.bodyTemplate || null;
    this.isHighlight = false; // We don't want the user object to be enumerable

    (0, _defineProperty.default)(this, 'user', {
      value: user
    });

    _vue.default.observable(this);
  }

  (0, _createClass2.default)(Message, [{
    key: "render",
    value: function render() {
      // Allow plugins to render their own messages if needed
      _GlobalApi.default.singleton().emit('message.render', {
        message: this
      });

      return this;
    }
  }, {
    key: "toHtml",
    value: function toHtml(messageList) {
      var _context;

      if (this.hasRendered) {
        return this.html;
      }

      this.hasRendered = true;
      var showEmoticons = _state.default.setting('buffers.show_emoticons') && !messageList.buffer.isSpecial();
      var userList = messageList.buffer.users;
      var useExtraFormatting = !messageList.buffer.isSpecial() && messageList.useExtraFormatting && this.type === 'privmsg';
      var blocks = (0, _MessageParser.default)(this.message, {
        extras: useExtraFormatting
      }, userList);

      _state.default.$emit('message.prestyle', {
        message: this,
        blocks: blocks
      });

      var content = (0, _Html.default)(blocks, showEmoticons);
      this.mentioned_urls = (0, _map.default)(_context = (0, _filter.default)(blocks).call(blocks, function (block) {
        return block.type === 'url';
      })).call(_context, function (block) {
        return block.meta.url;
      });
      this.html = content;
      this.maybeAutoEmbed();

      _state.default.$emit('message.poststyle', {
        message: this,
        blocks: blocks
      });

      return this.html;
    }
  }, {
    key: "maybeAutoEmbed",
    value: function maybeAutoEmbed() {
      var _context2;

      if (!this.mentioned_urls || this.mentioned_urls.length === 0) {
        return;
      } // Only auto preview links on user messages. Traffic, topics, notices, etc would get
      // annoying as they usually contain links of some sort


      if (this.type !== 'privmsg') {
        return;
      }

      var url = this.mentioned_urls[0];

      var whitelistRegex = _state.default.setting('buffers.inline_link_auto_preview_whitelist');

      whitelistRegex = (0, _trim.default)(_context2 = whitelistRegex || '').call(_context2);

      try {
        if (!whitelistRegex || !new RegExp(whitelistRegex, 'i').test(url)) {
          return;
        }
      } catch (err) {
        // A bad regex pattern will throw an error
        return;
      }

      this.embed.payload = url;
      this.embed.type = 'url';
    }
  }]);
  return Message;
}();

exports.default = Message;

function extractMessageId(message) {
  if (!message.tags) {
    return undefined;
  }

  return message.tags.msgid || message.tags['draft/msgid'] || undefined;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Message"]
window._kiwi_exports.libs.Message = exports.default ? exports.default : exports;
